export enum PURCHASE_STEP {
  PRODUCT = 'product',
  UPSELL = 'upsell',
  OPTIONS = 'options',
  CART = 'cart',
}
